import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';
import { type useNavigation } from 'app/hooks/navigation';

export function HeaderRight({
  navigation,
  route,
}: {
  navigation: ReturnType<typeof useNavigation>;
  route: { params: { url: string } };
}) {
  const { t } = useTranslation('one-channel');
  return (
    <Pressable
      onPress={() => navigation.navigate('add-chat-members', { url: route.params.url }, { pop: true })}
      style={{ padding: 8 }}
    >
      <Text color="surface.brand.default" fontWeight="700">
        {t('add')}
      </Text>
    </Pressable>
  );
}
